import "./Event.scss";
import { HiChevronDoubleDown } from "react-icons/hi";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { images } from "../../data/data";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { Link as Scroll } from "react-scroll";
import Banner from "../../components/Banner";

import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import PastSpeaker from "../../Container/pastSpeakers/PastSpeaker";

const EventPage = () => (
  <>
    <section className="event-bg section">
      <div className="banner">
        <Banner />
      </div>
      <article className="event-bg__container">
        <div className="event-bg__container-contents">
          <span className="past">Our Past Event</span>
          <h1 className="">
            STORIES OF <span>CHANGE</span>
          </h1>
          <div className="event-info">
            <p className="date">
              Held on, October 29<sup>th</sup>, 2022
            </p>
            <p className="venue">
              BOOC Lecture Theatre, Obafemi Awolowo University
            </p>
          </div>
        </div>

        <Scroll
          to="next-section"
          smooth={true}
          duration={100}
          delay={0}
          offset={100}
          style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="scroll-btn">
            <HiChevronDoubleDown />
            <span>Scroll Down</span>
          </div>
        </Scroll>
      </article>
    </section>

    <section className="section event">
      <article className="event__container container">
        <div className="event__description">
          <p>
            TEDxOAU is a platform for the best and brightest thinkers,
            visionaries, and teachers from within and without the university to
            share their ideas with the community. TEDxOAU is a community of
            curious souls who engage with ideas and each other. We believe
            passionately in the power of ideas to change attitudes, lives and,
            ultimately, the world. TEDxOAU is a community of curious souls who
            engage with ideas and each other. We believe passionately in the
            power of ideas to change attitudes, lives and, ultimately, the
            world.
            <br />
            <br />
            Our theme, &ldquo;STORY OF CHANGE&ldquo; is a call to action for
            everyone to be the change they want to see in the world. We believe
            that the world can be a better place if we all take responsibility
            for our actions and make conscious efforts to be the change we want
            to see.
            <br />
            <br />
          </p>
        </div>

        <PastSpeaker />

        <section className="section" id="next-section">
          <div className="section__header">
            <h1 className="section__title">THE EXPERIENCE</h1>
            <p className="section__title-center">
              Let&apos;s take you through the journey of TEDxOAU 2022
            </p>
          </div>

          <div className="event__experience">
            <div className="event__experience-photos">
              <p>Some moments in photos</p>
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 350: 2, 750: 2, 900: 3, 1200: 4 }}
              >
                <Masonry gutter="10px">
                  {images.map((image, i) => (
                    <img
                      key={i}
                      src={image}
                      data-aos="fade-down"
                      style={{ width: "100%", display: "block" }}
                      alt=""
                    />
                  ))}
                </Masonry>
              </ResponsiveMasonry>

              <Link
                to="https://www.flickr.com/photos/195944508@N04/shares/T8Lx12h2pR"
                target="_blank"
                rel="noreferrer"
                className="event__experience-btn"
              >
                <span>
                  See all photos <span>&rarr;</span>
                </span>
              </Link>
            </div>

            <div className="event__experience-videos">
              <p>Some moments in videos</p>
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
              >
                <Masonry gutter="10px">
                  {[
                    "https://www.youtube.com/embed/E_-bwKL-Q28",
                    "https://www.youtube.com/embed/3U9vX7zfGLA",
                    "https://www.youtube.com/embed/yrhs8DmJUQ0",
                  ].map((videoSrc, i) => (
                    <iframe
                      key={i}
                      width="100%"
                      height="315"
                      src={videoSrc}
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  ))}
                </Masonry>
              </ResponsiveMasonry>
              <Link
                to="https://linktr.ee/tedxoauofficial?fbclid=PAAaYKWuKFaKSp3HpH29JV2vc_qtKhpnFRMYJhJii9wVF-IvRJaaA4sBaDpvA"
                target="_blank"
                rel="noreferrer"
                className="event__experience-btn"
              >
                <span>
                  See all Videos <span>&rarr;</span>
                </span>
              </Link>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section__header">
            <h1 className="section__title">REVIEWS ABOUT THE EVENT</h1>
            <p className="section__title-center">
              What people are saying about TEDxOAU 2022
            </p>
          </div>
          <Swiper
            className="myer"
            watchSlidesProgress={true}
            slidesPerView={1}
            spaceBetween={10}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 250000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
            }}
            modules={[Autoplay, Pagination]}
          >
            <SwiperSlide>
              <div className="testimonial">
                <FaQuoteLeft className="quote-left" />
                <p className="testimonial__content">
                  I loved every bit of it, from the speakers to band that played
                  at the event, to the music. I rate it an 8/10.
                </p>
                <FaQuoteRight className="quote-right" />
                <p className="testimonial__name">Triumphant Adewoyin</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial">
                <FaQuoteLeft className="quote-left" />
                <p className="testimonial__content">
                  The anchorage was nice. The hosts tried their best in engaging
                  with the audience, solid 6-7/10. The speakers were also
                  brought stories of change. The lineup of the speakers was
                  great too, having them from different spheres of life and that
                  is commendable.
                </p>
                <FaQuoteRight className="quote-right" />
                <p className="testimonial__name">Taiwo Oluwapamilerin Isaac</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial">
                <FaQuoteLeft className="quote-left" />
                <p className="testimonial__content">
                  TEDxOAU was an amazing experience! I was truly inspired by the
                  speakers and their ideas. It&apos;s a platform that fosters
                  positive change in the community. I can&apos;t wait for the
                  next edition”
                </p>
                <FaQuoteRight className="quote-right" />
                <p className="testimonial__name">Sarah Adekunle</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial">
                <FaQuoteLeft className="quote-left" />
                <p className="testimonial__content">
                  It was an amazing event that blew my mind. Having to see that
                  all the hardwork and time we invested in the planning paid off
                  was a different kind of ecstasy. I can say for a fact that
                  TEDxOAU '22 was awesome and if I'd use the "IT girl talk",
                  that would mean me saying "it was a 10/10" and it
                  broke the scale even!
                </p>
                <FaQuoteRight className="quote-right" />
                <p className="testimonial__name">Precious Adeife Adewunmi.</p>
              </div>
            </SwiperSlide>
          </Swiper>
        </section>
      </article>
    </section>
  </>
);

export default EventPage;
